module.exports = __webpack_public_path__ + "img/Senparc.9e92130f.png";